export default __webpack_public_path__ + "static/media/73.c1ba10fe.png";